module.exports = __webpack_public_path__ + "img/large_logo.4b057515.svg";